// src/protocols/_generic/labels.ts
var GENERIC_COMPONENTS = {
  /** Whole-event summary card driven by an `EventViewHint.summaryFields`. */
  event: "GenericEvent",
  /** Whole-call summary card driven by a `CallViewHint.summaryFields`. */
  call: "GenericCall",
  /** Ordered EVM calls at exact definition-declared array paths. */
  callBatch: "EvmCallBatch",
  /** Decoded-STRUCT value card driven by a `DisplayHint.fields`. */
  struct: "GenericStruct"
};

export { GENERIC_COMPONENTS };
//# sourceMappingURL=chunk-RIC2ISCZ.js.map
//# sourceMappingURL=chunk-RIC2ISCZ.js.map